import React from "react";
import { Loader } from "@arcadis-intelligence/novus-design-system";
import { LoaderComponentStyles } from "../variants";

function LoaderComponent() {
    return <Loader {...LoaderComponentStyles} />;
}

export default LoaderComponent;
